import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, BrewersUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import moment from 'moment';

@Component({
    standalone: false,
    selector: 'app-project-overview',
    templateUrl: './project-overview.component.html',
    styleUrls: ['./project-overview.component.scss'],
})
export class ProjectOverviewComponent implements OnInit {
    filter: any = {};
    projects: any[];
    customerTypes: any[];
    isCustomerAdmin = false;
    salesPersons: any[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: BrewersUnitOfWork,
        private router: Router,
        private sessionInfo: SessionInformationService,
        private appInfo: AppInformationService,
        private auth: AuthService
    ) {}

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        this.projects = await this.uow.customers.getProjects('customer');
    }

    rowDoubleClick(e: any) {
        this.open(e.data);
    }

    open(customer?: any) {
        this.router.navigate([`/customers/${customer ? customer.id : 'new'}`]);
    }

    async delete(customer: any) {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        if (!(await confirm('Are you sure you want to delete the selected customer?', this.appInfo.settings.company))) return;

        selectedRows.forEach((row) => {
            row.deleted = new Date();
            row.deletedBy = this.auth.currentUser.userName;
        });
        await this.uow.commit();
        await this.getData();
    }
}
